export default __webpack_public_path__ + "locales/pt/Webhooks.json?hash=c18efb9204be70a521fc97e858298d32";